import { ImageName } from "@mcleod/images";
import { DataDisplayEvent, Label } from "@mcleod/components";
import { AutogenLayoutCommodityLookup } from "./autogen/AutogenLayoutCommodityLookup";

export class CommodityLookup extends AutogenLayoutCommodityLookup {
    labelHazmatOnDataDisplay(event: DataDisplayEvent) {
        const label = event.target as Label;
        label.text = null;
        if (event.rowData?.get("is_hazmat") === "Y") {
            label.imageName = ImageName.warning;
            label.imageColor = "red";
        }
    }
}
